import * as React from 'react';

import 'css!./__styles__/ConsoleOutput';

const ConsoleOutput = (props: React.PropsWithChildren) => {
  return <pre className="rc-ConsoleOutput">{props.children}</pre>;
};

export default ConsoleOutput;
